import { render, staticRenderFns } from "./ProductBuilderCard.vue?vue&type=template&id=7dd873b5&"
import script from "./ProductBuilderCard.vue?vue&type=script&lang=ts&"
export * from "./ProductBuilderCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports